import React, { useEffect } from "react";
import { Result, Card, Typography } from "antd";

const { Text } = Typography;

const FormSuccessClose = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.close();
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      style={{
        backgroundColor: "#d3d3d3",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "1rem",
      }}
    >
      <Card style={{ width: 500, textAlign: "center" }}>
        <Result
          status="success"
          title="Thank you for submitting the form!"
          subTitle="This tab will close automatically."
        />
        <Text type="secondary">
          If it doesn't close automatically, you may close this tab manually.
        </Text>
      </Card>
    </div>
  );
};

export default FormSuccessClose;
